import React from 'react';
import htmlParser from 'utils/html/htmlParser';
import styled from 'styled-components';
import { Padding } from 'styled-components-spacing';
import { FormattedMessage } from 'i18n';
import accordionStyles from 'routes/template/templates/default/contentRules/accordion/styles';
import StyledContainer from '../../components/StyledContainerComponent';
import { mediaQueries } from 'styles/utils/mediaQueries';
import DestinationLinks from './components/destinationLinks/DestinationLinksComponent';

function CoronaVirusTemplateComponent({ content, destinations }) {
  return (
    <Root>
      {content.title && <Title>{content.title}</Title>}
      <Padding vertical={{ tiny: 4, desktop: 4 }} horizontal={{ tiny: 1, desktop: 6 }}>
        {htmlParser(content.description)}
        <div className='accordion'>
          <h3 className='accordion-button'>
            <FormattedMessage
              id='noticeAboutTravelRestrictions'
              description='Notice about travel restrictions'
              defaultMessage='Notice about travel restrictions'
            />
          </h3>
          <div className='panel'>
            <DestinationLinks destinations={destinations} />
          </div>
        </div>
      </Padding>
    </Root>
  );
}

export default CoronaVirusTemplateComponent;

const Root = styled(StyledContainer)`
  width: 1024px;
  margin: 0 auto;
  padding: 0 15px;

  ${mediaQueries.fromAndBelow.desktop`
    width: 750px;
  `}

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%
  `}

  p {
    font-size: 16px;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 1rem;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1.5rem;
  }

  h1 {
    font-size: 32px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 20px;
  }

  h4 {
    font-size: 16px;
  }

  h5 {
    font-size: 13px;
  }

  h6 {
    font-size: 11px;
  }

  a.nh-cta {
    position: relative;
    display: inline-block;
    padding: 17px 60px 11px 16px;
    background-color: ${({ theme }) => theme.colors.adjacent.default};
    font-family: ${({ theme }) => theme.fonts.sansSerif};
    font-size: 1.8em;
    color: ${({ theme }) => theme.colors.text.white};
    cursor: pointer;
    user-select: none;
    line-height: 26px;

    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 4px;
      position: absolute;
      bottom: -7px;
      left: 0;
      background-color: ${({ theme }) => theme.colors.secondary.default};
    }
  }

  a.button {
    padding: 16px;
    background-color: ${({ theme }) => theme.colors.adjacent.default};
    border-radius: 4px;
    font-size: 1.6em;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text.white};
    text-decoration: none;
  }

  ${accordionStyles}
`;

const Title = styled.h1`
  width: 100%;
  margin-top: 130px;
  margin-bottom: 100px;
  font-size: 72px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.templates.header};
`;
